import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "recording",
  "use": "recording-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"recording\"><g clip-path=\"url(#recording_clip0_835_30)\"><circle cx=\"8\" cy=\"8\" r=\"5.5\" stroke=\"#000\" stroke-width=\"5\" /></g><defs><clipPath id=\"recording_clip0_835_30\"><path d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol